export default {
  originCity: 'Sélectionner la ville de départ',
  destinationCity: "Sélectionner la ville d'arrivée",
  direct: 'Direct',
  indirect: 'Une escale ou plus',
  getPrices: 'Obtenir les prix',
  directAvailable: 'Vol direct disponible dès',
}
